module.exports = __webpack_public_path__ + "img/pic1.4ad63604.png";